import Backbone from 'backbone'
import template from './slide-form.hbs'
import _ from 'lodash'
import periodReferenceTypeToggle from 'scoreboard/components/period-reference-type-toggle'
import RelativeOptions from 'scoreboard/components/relative-options'
import dropdown from 'scoreboard/components/dropdown'
import CalendarPeriodSelector from 'scoreboard/components/calendar-period-selector'
import formHelper from 'scoreboard/components/form-helper'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import selects from 'scoreboard/components/selects'
import periodSelectorDisplayed from 'scoreboard/components/period-selector-displayed'

/**
 * This is shared code for both creating and editing slides.  There is a good
 * amount in common between the two, but a lot is different too.
 */
var SlideForm = Backbone.View.extend({

	// this.model is a Slide

	className: 'slide-form',

	initialize: function(options = {}) {
		this.options = options
		this.toggle = periodReferenceTypeToggle()
		this.toggle.on('change', this._toggleChange.bind(this))
		this._cpSelector = new CalendarPeriodSelector({
			confirm: false,
			name: 'periodId',
			extraClass: 'aligned-selects',
			periodId: this.model.get('periodId')
		})
	},

	render: function() {
		this.$el.html(template(this.options))

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this.$('.toggle-container').append(this.toggle.el)
		this.toggle.render()
		this.$('.calendar-period-selector-container').append(this._cpSelector.el)
		this._cpSelector.render()

		var select = this.$('.relative-options')
		dropdown.idLabels(select, new RelativeOptions().generate(), 0)

		this.writeToDom()

		selects(this.$('select'))

		if (!periodSelectorDisplayed(this.options.itemContext)) {
			this.$('.period-panel').addClass('is-not-displayed')
		}

		return this
	},

	writeToDom: function() {
		var toggleVal = _.isNumber(this.model.get('periodId')) ? 'by-date' : 'relative'
		this.toggle.val(toggleVal, { silent: false })
		this._toggleChange(toggleVal)
		formHelper.writeToDom(this.model, this.el)
	},

	_toggleChange: function(val) {
		this.$('.calendar-period-selector-container').toggle(val === 'by-date')
		this.$('.relative-container').toggle(val === 'relative')
		this.trigger('change')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.toggle, this._cpSelector, this.labelField], 'remove')
	}

})

export default SlideForm

SlideForm.__filename__ = 'briefings/slide-form.js'
